/**
 * @file 用户信息
 * @author cuibolun(cuibolun@baijia.com)
 * @date 2021-03-04
 */

import {fetchUserInfo} from '../service/user';

export default {
    name: 'user',
    state: {
        userInfo: null,
        isLogin: false,
    },

    action: {
        getUserInfo() {
            return fetchUserInfo();
        }
    },

    reducer: {
        // @ts-ignore
        getUserInfo(state, action, error) {
            if (!error) {

                const {data} = action.payload;

                return {
                    ...state,
                    userInfo: data,
                    isLogin: !!data,
                };
            }

            return {...state};
        }
    }
};
